module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('router-view'), _vm._v(" "), _vm._m(0)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "addToHomeContainer"
    }
  }, [_c('div', {
    staticClass: "a2hs-title"
  }, [_vm._v("\n          Adicionar a Tela Inicial\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "a2hs-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "a2hs-text"
  }, [_vm._v("            \n          Quero Créditos\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "a2hs-btn"
  }, [_c('div', {
    attrs: {
      "id": "a2hs-btn-cancel"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "a2hs-btn-add"
    }
  }, [_vm._v("Adicionar")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3d669be","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/the-container.vue
// module id = +V9r
// module chunks = 36